import React from "react";
import { useTranslation } from "react-i18next";
import OutGoingRequestCard from "../../../../components/requests/OutGoingRequestCard";
import RequestsModel from "../../../../api/models/RequestsModel";

type OutGoingTabProps = {
  requests: RequestsModel[];
};
export const OutGoingTab = (props: OutGoingTabProps) => {
  const { requests } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <div className="w-full px-8 py-6 bg-white">
      <div className="flex flex-col gap-6">
        {requests.length > 0 &&
          requests.map((request) => <OutGoingRequestCard request={request} />)}
      </div>
    </div>
  );
};
